export default "__VITE_ASSET__DBHjXzp3__"